// extracted by mini-css-extract-plugin
export default {"logOutBtn":"normalMenuForProfile_logOutBtn__gO15n","settingBtn":"normalMenuForProfile_settingBtn__O2Xl5"};